import emitter, { EVENTS } from "./emitter";
import { ProduceStream, ProduceUser } from "../types";

export function getProduceStreams(user: ProduceUser): ProduceStream[] {
  const result: ProduceStream[] = [];
  result.push({
    id: user.user.id,
    user: user.user,
    stream: user.stream,
    hasAudio: user.constrains?.audioEnabled ?? false,
    hasVideo: user.constrains?.videoEnabled ?? false,
    isScreen: false,
    isSpeaking: user.isSpeaking,
  });
  if (user.constrains?.shareEnabled && user.screenStream) {
    result.push({
      id: user.user.id + "__screen",
      user: user.user,
      stream: user.screenStream,
      hasAudio: true,
      hasVideo: true,
      isScreen: true,
      isSpeaking: false,
    });
  }

  return result;
}

export function checkNeedMirrorReflection(stream: ProduceStream, me: ProduceUser | null): boolean {
  return (
    stream.id.includes("__screen") ||
    stream.id !== me?.user.id ||
    (!!me?.constrains &&
      typeof me.constrains.video === "object" &&
      typeof me.constrains.video.facingMode === "string" &&
      me.constrains.video.facingMode === "environment")
  );
}

function tryPlay(video: HTMLVideoElement) {
  video.play().catch(() => {
    setTimeout(
      () =>
        video?.play().catch((e) => {
          // eslint-disable-next-line no-console
          console.error(e);
          emitter.emit(EVENTS.USER_DID_NOT_INTERACT_DOC_FIRST, () => video?.play());
        }),
      500
    );
  });
}

export function updateVideoStream(video: HTMLVideoElement | null, stream: MediaStream): (() => void) | undefined {
  if (!video) return;

  if (video.srcObject !== stream) {
    video.srcObject = stream;
  }

  if (stream.getTracks().length > 0) {
    tryPlay(video);
  }

  const onPause = () => {
    if (stream.getTracks().length > 0) {
      tryPlay(video);
    }
  };

  video.addEventListener("pause", onPause);

  return () => {
    video.removeEventListener("pause", onPause);
  };
}
